module.exports = __webpack_public_path__ + "img/time_circle.0bb82fef.svg";